import * as tslib_1 from "tslib";
import { extend, getGUID, sanitizeGuid, stringIsNullOrEmpty } from "@pnp/common";
import { ClientSvcQueryable, MethodParams } from "@pnp/sp-clientsvc";
import { TermSets } from "./termsets";
import { TermStore } from "./termstores";
/**
 * Term Groups collection in Term Store
 */
var TermGroups = /** @class */ (function (_super) {
    tslib_1.__extends(TermGroups, _super);
    function TermGroups() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Gets the groups in this collection
     */
    TermGroups.prototype.get = function () {
        var _this = this;
        return this.sendGetCollection(function (d) {
            if (!stringIsNullOrEmpty(d.Name)) {
                return _this.getByName(d.Name);
            }
            else if (!stringIsNullOrEmpty(d.Id)) {
                return _this.getById(d.Id);
            }
            throw Error("Could not find Name or Id in TermGroups.get(). You must include at least one of these in your select fields.");
        });
    };
    /**
     * Gets a TermGroup from this collection by id
     *
     * @param id TermGroup id
     */
    TermGroups.prototype.getById = function (id) {
        var params = MethodParams.build()
            .string(sanitizeGuid(id));
        return this.getChild(TermGroup, "GetById", params);
    };
    /**
     * Gets a TermGroup from this collection by name
     *
     * @param name TErmGroup name
     */
    TermGroups.prototype.getByName = function (name) {
        var params = MethodParams.build()
            .string(name);
        return this.getChild(TermGroup, "GetByName", params);
    };
    return TermGroups;
}(ClientSvcQueryable));
export { TermGroups };
/**
 * Represents a group in the taxonomy heirarchy
 */
var TermGroup = /** @class */ (function (_super) {
    tslib_1.__extends(TermGroup, _super);
    function TermGroup(parent, _objectPaths) {
        if (parent === void 0) { parent = ""; }
        var _this = _super.call(this, parent, _objectPaths) || this;
        // this should mostly be true
        _this.store = parent instanceof TermStore ? parent : null;
        return _this;
    }
    Object.defineProperty(TermGroup.prototype, "termSets", {
        /**
         * Gets the collection of term sets in this group
         */
        get: function () {
            return this.getChildProperty(TermSets, "TermSets");
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Adds a contributor to the Group
     *
     * @param principalName The login name of the user to be added as a contributor
     */
    TermGroup.prototype.addContributor = function (principalName) {
        var params = MethodParams.build().string(principalName);
        return this.invokeNonQuery("AddContributor", params);
    };
    /**
     * Adds a group manager to the Group
     *
     * @param principalName The login name of the user to be added as a group manager
     */
    TermGroup.prototype.addGroupManager = function (principalName) {
        var params = MethodParams.build().string(principalName);
        return this.invokeNonQuery("AddGroupManager", params);
    };
    /**
     * Creates a new TermSet in this Group using the provided language and unique identifier
     *
     * @param name The name of the new TermSet being created
     * @param lcid The language that the new TermSet name is in
     * @param id The unique identifier of the new TermSet being created (optional)
     */
    TermGroup.prototype.createTermSet = function (name, lcid, id) {
        var _this = this;
        if (id === void 0) { id = getGUID(); }
        var params = MethodParams.build()
            .string(name)
            .string(sanitizeGuid(id))
            .number(lcid);
        this._useCaching = false;
        return this.invokeMethod("CreateTermSet", params)
            .then(function (r) { return extend(_this.store.getTermSetById(r.Id), r); });
    };
    /**
     * Gets this term store's data
     */
    TermGroup.prototype.get = function () {
        return this.sendGet(TermGroup);
    };
    /**
     * Updates the specified properties of this term set, not all properties can be updated
     *
     * @param properties Plain object representing the properties and new values to update
     */
    TermGroup.prototype.update = function (properties) {
        return this.invokeUpdate(properties, TermGroup);
    };
    return TermGroup;
}(ClientSvcQueryable));
export { TermGroup };
//# sourceMappingURL=termgroup.js.map